<template>
  <div id="A0" class="sub">
    <div class="wrapper">
      <kg-header :headerType=1 />
      <div class="inner_static">
        <div id="news_detail_div">
          <h1 class="tit1">NEWS詳細</h1>
          <ul class="lst_find">
            <li>
              <div>
                <span>{{this.title}}</span>
              </div>
              <div>
                <span class="date_span">{{formatDay(this.day)}}</span>
              </div>
            </li>
            <li>
              <span>{{this.text}}</span>
            </li>
          </ul>
          <div class="btn_area">
            <a class="btn1" @click="btnBackClick()">一覧に戻る</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as App from '../../utils/App'
import {KG_STORAGE_KEY} from '../../constants/App'

// kaggul Module
import Header from '../components/common/HomeIconHeader'

export default {
  components: {
    'kg-header': Header
  },
  data () {
    return {
      day: '',
      title: '',
      text: ''
    }
  },
  methods: {
    init: function () {
      let temp = App.getLocalStorage(KG_STORAGE_KEY.SELECT_NEWS_DATA)
      this.day = temp.day
      this.title = temp.title
      this.text = temp.text
      App.removeLocalStorage(KG_STORAGE_KEY.SELECT_NEWS_DATA)
    },
    btnBackClick: function () {
      this.$router.push('/kagull/news')
    },
    formatDay: function (dayStr) {
      if (!dayStr) return ''
      let temp = dayStr.split('')
      let ret = ''
      for (let i = 0; i < temp.length; i++) {
        if (i > 3 && i % 2 === 0) {
          if (temp[i] === '0') {
            ret += '.'
          } else {
            ret += ('.' + temp[i])
          }
        } else {
          ret += temp[i]
        }
      }
      return ret
    }
  },
  created: function () {
    this.init()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/NewsDetail.vue